import React from "react";
import { Box, styled } from "@mui/material";
import { SchedulingSection } from "../styles/styled.components";

const SelectorContainer = styled(Box)({
  width: "100%",
  height: "40px",
  display: "flex",
  overflow: "hidden",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  margin: "0 auto",
});

const OptionButton = styled(Box)(({ $isSelected, $optionType }) => ({
  flex: 1,
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  backgroundColor: $isSelected
    ? $optionType === "Forward"
      ? "#2196f3"
      : $optionType === "Backward"
      ? "#ff8787"
      : $optionType === "Back + Forward"
      ? "#7dfa87"
      : "#ffffff"
    : "#ffffff",
  color: $isSelected
    ? $optionType === "Back + Forward"
      ? "#333333"
      : "#ffffff"
    : "#333333",
  fontWeight: $isSelected ? 600 : 400,
  fontSize: "14px",
  transition: "all 0.2s ease",
  userSelect: "none",
  "&:hover": {
    backgroundColor: $isSelected
      ? $optionType === "Forward"
        ? "#1976d2"
        : $optionType === "Backward"
        ? "#e57373"
        : $optionType === "Back + Forward"
        ? "#66c46f"
        : "#f5f5f5"
      : "#f5f5f5",
  },
  borderRight: "1px solid #e0e0e0",
  "&:last-child": {
    borderRight: "none",
  },
}));

const SchedulingSelector = ({ selection, onSelectionChange }) => {
  const handleSelect = (option) => {
    if (onSelectionChange) {
      onSelectionChange(option);
    }
  };
  return (
    <>
      <SchedulingSection>
        <div className="num_title">방향 설정</div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            width: "100%",
            alignItems: "flex-start",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              padding: "4px 16px",
              minWidth: "350px",
              width: "100%",
              cursor: "pointer",
            }}
          >
            <SelectorContainer>
              <OptionButton
                $isSelected={selection === "Forward"}
                $optionType={"Forward"}
                onClick={() => handleSelect("Forward")}
              >
                Forward
              </OptionButton>
              <OptionButton
                $isSelected={selection === "Back + Forward"}
                $optionType={"Back + Forward"}
                onClick={() => handleSelect("Back + Forward")}
              >
                Back + Forward
              </OptionButton>
              <OptionButton
                $isSelected={selection === "Backward"}
                $optionType={"Backward"}
                onClick={() => handleSelect("Backward")}
              >
                Backward
              </OptionButton>
            </SelectorContainer>
          </Box>
        </div>
      </SchedulingSection>
    </>
  );
};

export default React.memo(SchedulingSelector);
